// extracted by mini-css-extract-plugin
export default {"wrapper":"Sequence_wrapper__apRdy","input":"Sequence_input__gf9A4"};